<template>
   <div>
   <div class="flex items-center">
            <img  @click="back" class="arrow-back" src="../../../assets/galochka.svg" alt="">
            <p    @click="back" class="font-bold text-sm ml-2 text-additional-text">Мои команды</p>
    </div>

    <div class="mt-8 sm:mt-5 flex justify-between relative ">
        <p class="team-member-label" :class="member.is_captain ? 'green-label' : 'yellow-label'">{{member.is_captain ? 'Капитан' : 'Участник'}}</p>
        <img @click.stop="openBox" v-if="(amICaptain && !member.is_captain) || (isMe && !member.is_captain)" src="../../../assets/open-menu.png" alt="" class="menu-dots">
    </div>
    <div class="mt-4">
          <!-- <select-box placeholder="Без сортировки" class="text-menuOrder-dark-blue md:pr-5"
          is_place no_padding fontIsNormal hideHeading  hideArrow positionBottomInfo
          :listItems="options"
          v-model="selected_filter"
          ref="sortSelectStat">
          </select-box> -->

          <select-box
          :listItems="options"
          :no_padding="false"
          placeholder="Без сортировки"
          class="w-full"
          v-model="selected_filter"
          ref="sortSelectStat"
          >
          </select-box>
    </div>

    <div>
     <p class="label-member">
      Имя игрока
     </p>
     <p class="info-member">
     {{member.name}}
     </p>
    </div>
       <div>
     <p class="label-member">
         Номер телефона
     </p>
     <p class="info-member">
      {{member.phone}}
     </p>
    </div>
       <div>
     <p class="label-member">
       E-mail
     </p>
     <p class="info-member">
       {{member.email}}
     </p>
    </div>
        <confirm-delete v-if="deleteMemberModal" key="delete_modal"  @close="deleteMemberModal = false"
                    @white_button="deleteMember " @yellow_button="deleteMemberModal = false"

                    :html="` Хотите удалить участника <span class='text-brand-light'>${member.name}</span> из команды <p class='text-brand-light' style='word-break: break-all'>${team.name}</p>?`"
                    :button_text_firs="'Удалить'" :button_text_second="'Отменить'"
                    class="z-100 flex absolute pin w-64"></confirm-delete>

    <confirm-delete v-if="appointCaptainModal" key="captain-modal"  @close="appointCaptainModal = false"
                          @white_button="appointCaptain" @yellow_button="appointCaptainModal = false"
                          :html="`Назначить участника <span class='text-brand-light'>${member.name}</span> капитаном команды <p class='text-brand-light' style='word-break: break-all'>${team.name}</p>?`"
                          :button_text_firs="'Назначить'" :button_text_second="'Отменить'"
                          class="z-100 flex absolute pin"></confirm-delete>

                              <reg-modal v-if="deletedModal" class="px-40" @close="toTeams">
            <p class="text-sm text-center font-bold ">
                Участник <span class="text-brand-light"> {{member.name}} </span> удален из команды
            </p>
             <p class="text-sm mt-8 mb-3 text-center mt-10">
                Вы можете вернуть участника в команду, отправив ему приглашение из Личного кабинета
            </p>
   </reg-modal>

    <reg-modal v-if="newCapModal" class="px-40" @close="toTeams">
            <p class="text-sm text-center font-bold ">
                <span class="text-brand-light"> {{member.name}} </span> назначен капитаном команды
                <span class="text-brand-light" style='word-break: break-all'> {{team.name}} </span>
            </p>
             <p class="text-sm mt-8 mb-3 text-center mt-10">
               Ваш статус в команде  <span class="text-brand-light" style="word-break: break-all"> {{team.name}} </span>
               изменен на  <span class="text-brand-light" style='word-break: break-all'> Участник </span>
            </p>
   </reg-modal>
    <reg-modal v-if="leftModal" class="px-40" @close="toTeams">
            <p class="text-sm text-center font-bold ">
            <span class="text-brand-light">  {{user.name}}</span>, Вы вышли из команды <span class="text-brand-light break-all" style='word-break: break-all'> {{team.name}} </span>
            </p>
             <p class="text-sm mt-8 mb-3 text-center mt-10">
            </p>
   </reg-modal>
      <confirm-delete v-if="leaveConfirm" key="leave_modal"  @close="leaveConfirm = false"
                          @white_button="leaveTeam" @yellow_button="leaveConfirm = false"
                          :html="`Хотите выйти из команды <span class='text-brand-light' style='word-break: break-all'>${team.name}</span>?`"
                          :button_text_firs="'Выйти'" :button_text_second="'Отменить'"
                          class="z-100 flex absolute pin"></confirm-delete>
   </div>
</template>
<script>
import SelectBox from '../../partners/selectbox.vue';
import ConfirmDelete from '@/views/partners/events/order/delete-modal.vue';
import regModal from '@/views/partners/current-registration/registration-layout/registration-modal.vue';
import players from '@/clients/player.js';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'teamMemberInfo',
  props: ['member', 'team', 'amICaptain', 'memberId'],
  components: { SelectBox, ConfirmDelete, regModal },
  data() {
    return {
      options: {
        0: { name: 'Назначить капитаном', value: 'appointCap' },
        1: { name: 'Удалить игрока', value: 'delete' },
      },
      selected_filter: 3,
      deleteMemberModal: false,
      appointCaptainModal: false,
      deletedModal: false,
      newCapModal: false,
      leaveConfirm: false,
      leftModal: false,

    };
  },
  created() {
    this.isMe ? this.options = { 2: { name: 'Выйти из команды', value: 'leave' } } : '';
  },
  methods: {
    ...mapActions(['refreshUser']),
    back() {
      this.$router.go(-1);
    },
    openBox() {
      this.$refs.sortSelectStat.openBox();
    },
    toTeams() {
      this.refreshUser(players);
      this.$router.push('/players/my-teams');
    },
    leaveTeam() {
      players.delete(`teams/${this.team.id}/leave`).then(() => {
        this.leaveConfirm = false;
        this.leftModal = true;
      });
    },
    deleteMember() {
      players.delete(`/teams/${this.team.id}/players`, { params: { user_id: this.member.user_id } }).then((resp) => {
        this.deleteMemberModal = false;
        this.deletedModal = true;
      });
    },
    appointCaptain() {
      players.patch(`/teams/${this.team.id}/captain`, {
        user_id: this.member.user_id,
      }).then((resp) => {
        this.appointCaptainModal = false;
        this.newCapModal = true;
      });
    },
  },
  computed: {
    ...mapState({
      userId: state => state.auth.user.id,
      user: state => state.auth.user,
    }),
    isMe() {
      return this.userId == this.memberId;
    },
  },

  watch: {
    selected_filter() {
      if (this.selected_filter == 0) {
        this.appointCaptainModal = true;
        this.selected_filter = 3;
      } else if (this.selected_filter == 1) {
        this.deleteMemberModal = true;
        this.selected_filter = 3;
      } else if (this.selected_filter == 2) {
        this.leaveConfirm = true;
        this.selected_filter = 3;
      }
    },
  },
};
</script>
<style scoped>

.label-member {
font-weight: bold;
font-size: 10px;
line-height: 12px;
color: #979797;
margin-top: 20px;
}
.info-member {
font-weight: bold;
font-size: 14px;
line-height: 17px;
margin-top:5px;
}
  >>>.team-member-label {
    width: 81px;
    text-align: center;
    @apply text-white font-bold py-1 px-3 text-10px rounded-sm

  }
  >>>.green-label {
    background-color: #00BD52;
  }
  >>>.yellow-label {
    background-color: #FFCE42;;
  }
    .menu-dots {
    position: absolute;
    right: 0px;
    top: -17px;
    padding: 10px;
  }
</style>
